import { render, staticRenderFns } from "./PlacementsTableHorizontal.tmplacements.vue?vue&type=template&id=8bf17c7c&scoped=true&lang=html&"
import script from "./PlacementsTableHorizontal.tmplacements.vue?vue&type=script&lang=js&"
export * from "./PlacementsTableHorizontal.tmplacements.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsTableHorizontal.tmplacements.vue?vue&type=style&index=0&id=8bf17c7c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf17c7c",
  null
  
)

export default component.exports